import { Button } from "@newsela/angelou";
import { useRouter } from "next/router";

import { internalToolingPanelCss } from "./InternalToolingPanel.style";

const InternalToolingPanel = () => {
  const router = useRouter();
  const { query } = router;
  const { show_internal_tooling: showInternalTooling } = query;
  const close = () => {
    const closedQuery = Object.assign({}, query);
    delete closedQuery.show_internal_tooling;
    router.replace({ query: closedQuery });
  };
  if (showInternalTooling !== "true") return null;
  return (
    <div css={internalToolingPanelCss}>
      <Button onClick={close}>Close</Button>
      <h1>Internal Tooling</h1>
      <p>
        There are currently no internal tools available. If you have a request
        for an internal tool that could be useful on any / every Lyceum page,
        reach out to the Front End Platfrom team to discuss that.
      </p>
    </div>
  );
};

export default InternalToolingPanel;
